module.exports = __webpack_public_path__ + "assets/img/jumpMask.d372e16e.jpg";